export const MAX_DELAY_MS = 10000;
export const RELOAD_DELAY_NOISE_MS = 1000;
export function getReloadDelayMs(connectionAttempts30s) {
    const noise = (2 * Math.random() - 1) * RELOAD_DELAY_NOISE_MS;
    const baseDelayMs = Math.pow(2, connectionAttempts30s) * 1000;
    const delay = Math.min(baseDelayMs, MAX_DELAY_MS) + noise;
    return delay;
}
export class ConnectionAttemptCounter {
    attemptsInLast30s = 0;
    recordAttempt = () => {
        this.attemptsInLast30s += 1;
        setTimeout(() => {
            this.attemptsInLast30s -= 1;
        }, 30000);
    };
}
//# sourceMappingURL=reconnectUtils.js.map